<template>
  <div class="about-page-container">
    <HomePage />
    <div v-html="aboutContent"></div>
  </div>
</template>

<script>
// Import the HTML content using raw-loader
import aboutContent from '../../../public/about-content.html';

export default {
  name: 'AboutPage',
  data() {
    return {
      aboutContent
    };
  }
};
</script>

<style scoped>
h1 {
  color: #42b983;
}

.title {
  color: #323232;
  font-size: 1.8rem;
  margin-bottom: 1.5rem;
  font-weight: 600;
  border-bottom: 2px solid #42b983;
  padding-bottom: 0.5rem;
  display: inline-block;
}

.about-page-container {
  padding: 20px;
}
</style>
